import styled from "styled-components";
import { IconButton } from "@mui/material";
import { styled as muiStyled } from "@mui/material/styles";
import { InfoOutlined, Close as CloseIconMui } from "@mui/icons-material";

export const ModalContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  box-sizing: border-box;
  width: 464px;
  max-width: calc(100vw - 32px);
  min-height: 233px;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  padding: 16px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 16px 48px 0px rgba(0, 0, 0, 0.24);
  outline: none;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  box-sizing: border-box;
  padding: 0 16px;
`;

export const Title = styled.h2`
  margin: 0;
  font-family: "Gotham", sans-serif;
  font-size: 22px;
  font-weight: 400;
  line-height: 28px;
  color: #202224;
`;

export const CloseButton = muiStyled(IconButton)({
  width: "48px",
  height: "48px",
  padding: "8px",
  color: "rgba(0, 0, 0, 0.54)",
  flexShrink: 0,
});

export const CloseIcon = muiStyled(CloseIconMui)({
  fontSize: "24px",
});

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  justify-content: center;
  box-sizing: border-box;
  gap: 16px;
  padding: 0 24px 0 0;
`;

export const Subtitle = styled.p`
  margin: 0 auto;
  width: 100%;
  max-width: 416px;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  color: #202224;
`;

export const NoticeRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  gap: 8px;
`;

export const InfoIcon = muiStyled(InfoOutlined)({
  fontSize: "24px",
  color: "#1C1B1F",
  flexShrink: 0,
});

export const NoticeMarkdown = styled.span`
  flex: 1;
  min-width: 0;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.17px;
  color: #444142;

  p {
    display: inline;
    margin: 0;
  }
`;

export const ExternalPortalLink = styled.a`
  color: #d33100;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
`;

export const MarkdownStrong = styled.strong`
  color: #d33100;
  font-weight: 500;
  text-decoration: underline;
`;
